<template>
  <section class="section" v-if="fetchedStructure">
    <page-header title="Rapporter"></page-header>
    <div
      class="
        box
        date-picker__container--no-right-margin
        has-background-primary has-text-white
      "
      style="position: relative"
    >
      <div class="dashboard-column">
        <div class="date-picker__container--padding level">
          <div
            class="
              level-left
              has-text-centered
              date-picker__loader--display-block
            "
              v-if="selectedStat.datePicker.visible"
          >
            <local-date-range-picker
              :initialRange="dateRange"
              @updateDate="updateDate"
              :loading="isFetching"
              class="
                is-fullwidth
                level-item
                date-picker date-picker__container--display-block
              "
            />
          </div>
          <div class="level-right">
            <div v-for="dropdown in selectedStat.dropdowns" :key="dropdown.key">
              <b-select
                v-model="dropdown.selected"
                @input="loadData"
                class="px-2 is-hidden-mobile is-hidden-tablet-only"
              >
                <option
                  v-for="option in dropdown.options"
                  :value="option.key"
                  :key="option.key"
                >
                  {{ option.label }}
                </option>
              </b-select>
            </div>
            <div
              v-for="action in selectedStat.actions"
              class="action-padding"
              :key="action.key"
            >
              <button
                class="button is-primary-passive"
                @click.prevent="exportAsCsv"
              >
                <span v-if="action.icon" class="icon is-small"
                  ><i :class="action.icon"></i
                ></span>
                <span>{{ action.label }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-hcentered is-multiline">
      <div class="column is-12 is-3-desktop is-2-fullhd">
        <b-select
          v-model="selectedStat"
          @input="loadData"
          class="mobileDashboardNavigation"
        >
          <optgroup
            :label="group.label"
            v-for="(group, index) in structure.groups"
            :key="index"
          >
            <option v-for="stat in group.stats" :value="stat" :key="stat.key">
              {{ stat.label }}
            </option>
          </optgroup>
        </b-select>
        <div v-for="dropdown in selectedStat.dropdowns" :key="dropdown.key">
          <b-select
            v-model="dropdown.selected"
            @input="loadData"
            class="mobileDashboardNavigation"
            style="margin-top: 15px"
          >
            <option
              v-for="option in dropdown.options"
              :value="option.key"
              :key="option.key"
            >
              {{ option.label }}
            </option>
          </b-select>
        </div>
        <aside class="menu dashboardNavigation">
          <div v-for="(group, index) in structure.groups" :key="index">
            <ul class="menu-list">
              <p class="categoryLabel">{{ group.label }}</p>
              <li v-for="stat in group.stats" :key="stat.endpoint">
                <a
                  @click="onStatSelected(stat)"
                  :class="{
                    'is-active': stat.endpoint === selectedStat.endpoint,
                  }"
                  style="display: flex; justify-content: space-between"
                >
                  {{ stat.label }}
                </a>
              </li>
            </ul>
          </div>
        </aside>
      </div>
      <div
        class="column is-12 is-9-desktop is-9-fullhd"
        v-if="statData['data'] !== undefined && statData['data'].length === 0"
        :class="{ 'dashboard__overlay--blurry': isFetching }"
      >
        Ingen data for det valgte interval
      </div>
      <div
        class="column is-12 is-6-desktop"
        style="overflow-x: auto"
        v-else
        :class="{ 'dashboard__overlay--blurry': isFetching }"
      >
        <table class="table is-fullwidth is-striped">
          <thead>
            <tr>
              <th
                :width="column.width"
                v-for="column in statData['columns']"
                :key="column.id"
                class="table__width-placement"
              >
                {{ column.header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(entry, index) in statData['data']"
              :key="entry.id"
              class="last-child-invisible"
            >
              <td v-for="column in statData['columns']" :key="column.key">
                <span v-if="column.key === 'indexed'">{{ index + 1 }}</span>
                <span v-else>{{ entry[column.key] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="column is-4 is-3-desktop is-4-fullhd"
        v-if="statData['data'] !== undefined && statData['data'].length > 0"
        :class="{ 'dashboard__overlay--blurry': isFetching }"
      >
        <doughnut
          :chart-data="dataCollection"
          :headline="donutHeadline"
        ></doughnut>
      </div>
    </div>
  </section>
</template>

<script>
import PageHeader from "@elems/pageHeader";
import Doughnut from "@elems/DoughnutChart.vue";
import InputSelect from "../../elements/form/InputSelect.vue";
import LocalDateRangePicker from "./components/DateRangePicker.vue";
import Loader from "@elems/loader.vue";

const moment = require("moment");

export default {
  components: {
    PageHeader,
    Doughnut,
    InputSelect,
    LocalDateRangePicker,
    Loader
  },
  data() {
    return {
      statData: {},
      dateRange: {
        startDate: moment()
          .startOf("month")
          .toDate(),
        endDate: moment()
          .endOf("day")
          .toDate()
      },
      structure: {},
      selectedStat: null,
      fetchedStructure: false,
      isFetching: true,
      colors: ["#2d435b", "#b5bd00", "#955251", "#EFC05096"]
    };
  },
  created() {
    this.loadStructure();
  },
  computed: {
    dataCollection() {
      return {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.colors,
            data: this.statData["doughnutData"]
          }
        ]
      };
    },
    labels() {
      let labels = this.statData["data"].map((entry, index) => {
        return entry.name;
      });
      if (labels.length > 3) {
        labels = labels.splice(0, 3);
        labels[labels.length] = "Resten";
      }
      return labels;
    },
    donutHeadline() {
      return this.statData["total"];
    }
  },
  methods: {
    onStatSelected(stat) {
      this.selectedStat = { ...stat };
      this.loadData();
    },
    updateDate({ startDate, endDate }) {
      this.dateRange = { startDate, endDate };
      this.loadData();
    },
    loadData() {
      this.isFetching = true;
      const params = {
        key: this.selectedStat.endpoint,
        date: {
          start: this.dateRange.startDate,
          end: this.dateRange.endDate
        },
        options: this.selectedStat.dropdowns.map(dropdown => ({
          key: dropdown.key,
          selected: dropdown.selected
        }))
      };
      axios
        .post("/api/rapporter/" + this.selectedStat.endpoint, { params })
        .then(({ data }) => {
          this.statData = data;
          this.isFetching = false;
        });
    },
    loadStructure() {
      axios.get("/api/rapporter/structure").then(({ data }) => {
        this.structure = data;
        this.structure.groups.forEach(group => {
          let stat = group.stats.find(stat => {
            return stat.endpoint === this.structure.meta.selectedStat;
          });
          if (stat !== undefined) this.selectedStat = stat;
        });
        this.loadData();
        this.fetchedStructure = true;
      });
    },
    exportAsCsv() {
      const params = {
        key: this.selectedStat.endpoint,
        date: {
          start: this.dateRange.startDate,
          end: this.dateRange.endDate
        },
        options: this.selectedStat.dropdowns.map(dropdown => ({
          key: dropdown.key,
          selected: dropdown.selected
        }))
      };
      axios
        .post("/api/rapporter/export/" + this.selectedStat.endpoint, { params })
        .then(response => {
          this.downloadCsv(response);
          this.$store.dispatch("setSuccess", "Eksport succesfuld");
        })
        .catch(error => {
          this.$store.dispatch("setError", "Der opstod en fejl");
        });
    },
    downloadCsv(response) {
      const url = window.URL.createObjectURL(
        new Blob(["\ufeff" + response.data])
      );
      const cd = response.headers["content-disposition"];
      let fileLink = document.createElement("a");
      fileLink.href = url;
      fileLink.setAttribute("download", cd.match(/filename=(.+)/)[1]);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  }
};
</script>



<style lang="scss">
.mobileDashboardNavigation {
  width: 100%;

  .select,
  .select select {
    width: 100%;
  }

  @media (min-width: 1024px) {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.action-padding {
  @media (min-width: 768px) {
    padding-left: 4px;
    padding-right: 4px;
  }

  @media (max-width: 768px) {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

.dashboardNavigation {
  @media (max-width: 1023px) {
    display: none;
  }

  div:not(:first-child) .categoryLabel {
    margin-top: 1.2em;
  }
}

.categoryLabel {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 0.9em;
}

.dashboard-column {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.dashboard {
  &__overlay {
    &--blurry {
      filter: blur(4px);
      transition: 20ms filter linear;
    }
  }
}

.table {
  table-layout: fixed;
}

.date-picker {
  min-width: 250px;
}

.navbar-item:hover {
  cursor: pointer;
  color: white;
}

@media (max-width: 1023px) {
  .is-active {
    background-color: #98ca3c;
    color: #035980;
  }

  .reverse-columns {
    flex-direction: column-reverse;
    display: flex;
  }

  .box {
    padding: 0%;
  }

  .date-picker {
    padding-bottom: 2%;

    &__container {
      &--padding {
        padding: 2%;
      }

      &--display-block {
        display: block !important;
      }

      &--no-right-margin {
        margin-right: 0em;
      }
    }

    &__loader {
      &--display-block {
        display: block;
      }
    }
  }
}

.level-item {
  &:not(:last-child) {
    margin-bottom: 0em;
  }
}

.dashboard-navbar {
  box-shadow: none;
  min-height: 0px !important;
}
</style>
